import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "context/auth";
import useRoles from "customHooks/useRoles";

function ProtectedRoutes() {
  const [auth] = useAuth();
  const { roles, permissions, initRoles } = useRoles();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // if not logged in
    const isAuthPage = location.pathname.match(/auth/);

    if (!auth.token && !isAuthPage) {
      navigate("/auth/login");
    }
    // const isReports = location.pathname.match(/reports/);
    const isRequests = location.pathname.match(/requests/);
    const isUsers = location.pathname.match(/users/);
    const isRegulationPlansReport = location.pathname.match(/reports\/1/);
    const isUsersActionsReport = location.pathname.match(/reports\/2/);
    const isPaymentReport = location.pathname.match(/reports\/3/);
    const isDashboardReport = location.pathname.match(/reports\/4/);
    // const isDashboardReport = location.pathname.match(/reports\/4/);
    const isChangeZone = location.pathname.match(/changezone/);
    // {permissions.employeeWithChangeRequests && (
    //   <Route path="/requests" element={<Requests />} />
    // )}
    if (auth.token && initRoles) {
      if (
        isRequests &&
        !roles.manager &&
        !roles.people &&
        !permissions.employeeWithChangeRequests
      ) {
        navigate("/");
      }
      if (isUsersActionsReport && !roles.systemAdmin) {
        navigate("/");
      }
      if (
        isRegulationPlansReport &&
        !roles.manager &&
        !roles.systemAdmin &&
        !permissions.employeeWithRegulationPlansReport
      ) {
        navigate("/");
      }
      if (
        isPaymentReport &&
        !roles.manager &&
        !roles.systemAdmin &&
        !permissions.employeeWithPaymentReport
      ) {
        navigate("/");
      }
      if (
        isDashboardReport &&
        !roles.manager &&
        !roles.systemAdmin &&
        !permissions.employeeWithDashboardReport
      ) {
        navigate("/");
      }
      if (isUsers && !roles.systemAdmin) {
        navigate("/");
      }
      if (isChangeZone && !permissions.employeeWithChangeRequests) {
        navigate("/");
      }
    }
  }, [auth.token, initRoles]);

  if (!initRoles) return null;
  return <Outlet />;
}

export default ProtectedRoutes;
